<p-dialog [(visible)]="visible" [modal]="true" [closable]="!submitting" (onHide)="onDialogHide()" [header]="'payment.addCardUsd' | transloco">
  <ng-container *ngIf="loading">
    <div class="spinner-container">
      <p-progress-spinner ariaLabel="loading" />
    </div>
  </ng-container>

  <div id="stripe-payment-element-container" [style.display]="loading ? 'none' : 'block'"></div>

  <p class="stripe-error" *ngIf="errorMessage">{{ errorMessage }}</p>

  <div class="stripe-actions" *ngIf="!loading">
    <button pButton [label]="'payment.confirmCard' | transloco" [disabled]="submitting" (click)="submitCard()" class="p-button"></button>
  </div>
</p-dialog>
